import type { Ref } from 'vue'
import { onBeforeUnmount, watch } from 'vue'

export function useOverlayHistory(opened: Ref<boolean>, key: string) {
    const marker = `cineflow:${key}`
    let ownsEntry = false
    let backTimer: number | undefined

    function pushEntry() {
        if (ownsEntry) { return }
        window.clearTimeout(backTimer)
        window.history.pushState({ ...window.history.state, cineflowOverlay: marker }, '')
        ownsEntry = true
    }

    function releaseEntry() {
        if (!ownsEntry) { return }
        ownsEntry = false
        if (window.history.state?.cineflowOverlay !== marker) { return }
        window.clearTimeout(backTimer)
        backTimer = window.setTimeout(() => window.history.back(), 48)
    }

    function open() {
        if (opened.value) { return }
        pushEntry()
        opened.value = true
    }

    function close() {
        if (!opened.value) { return }
        opened.value = false
    }

    function onPopState() {
        const activeMarker = window.history.state?.cineflowOverlay
        if (opened.value && ownsEntry && activeMarker !== marker) {
            ownsEntry = false
            opened.value = false
            return
        }
        if (!opened.value && activeMarker === marker) {
            window.clearTimeout(backTimer)
            backTimer = window.setTimeout(() => window.history.back(), 0)
        }
    }

    watch(opened, isOpen => isOpen ? pushEntry() : releaseEntry(), { flush: 'sync' })
    window.addEventListener('popstate', onPopState)
    onBeforeUnmount(() => {
        window.clearTimeout(backTimer)
        window.removeEventListener('popstate', onPopState)
    })

    return { open, close }
}
